import Vue from "vue";
import Router from "vue-router";
import Path from "./PathEnum";
import Name from "./NameEnum";
import Main from "@/module/main/page/Main.vue";
import ApprovalResult from "@/module/main/page/ApprovalResult.vue";
import { ApprovalResultModeEnum as Mode } from "@/module/main";
import ExternalSite from '@/module/main/page/ExternalSite.vue';
import AccessDenied from "@/module/main/page/AccessDenied.vue";

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: Path.MAIN,
            name: Name.MAIN,
            component: Main
        },
        {
            path: Path.REJECTED_APPLICATION,
            name: Name.REJECTED_APPLICATION,
            component: ApprovalResult,
            props: {
                mode: Mode.REJECTED
            }
        },
        {
            path: Path.ACCEPTED_APPLICATION,
            name: Name.ACCEPTED_APPLICATION,
            component: ApprovalResult,
            props: {
                mode: Mode.ACCEPTED
            }
        },
        {
            path: Path.EXTERNAL_SITE_IN_LOKI,
            name: Name.EXTERNAL_SITE_IN_LOKI,
            component: ExternalSite
        },
        {
            path: Path.ACCESS_DENIED,
            name: Name.ACCESS_DENIED,
            component: AccessDenied
        }
    ]
});
